require('./brokerSuspendedMiFIDTest.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const moment = require('moment');
const { connect } = require('react-redux');

// @actions
const BrokerCreateTransferOfDerivativesAction = require('actions/brokerCreateTransferOfDerivatives');
const BrokerCashChargeActions = require('actions/brokerCashCharge');
const BrokerRightsBuyActions = require('actions/brokerRightsBuy');
const BrokerStocksPurchaseOrderActions = require('actions/brokerStocksPurchaseOrder');
const BrokerSubscriptionActions = require('actions/brokerSubscription');
const InternalTransferFundActions = require('actions/brokerInternalTransferFunds');
const BrokerExternalTransferFundActions = require('actions/externalTransferFund');

// @commons
const { OKLink } = require('commonsComponents/OKLink');


// @components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @constants
const {
    DATE_FORMAT_COMPLETE,
    HYPHEN
} = require('constants/index');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { isPrivateEquityTest } = require('mifid/utilities/mifidPrivateEquityHelper');

class BrokerSuspendedMiFIDTest extends React.Component {

    componentDidMount() {
        const { immBrokerConvenienceMiFIDTest, onContinueOperation } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['test', 'testToEvaluate', 'tipoTest'])
        if (isPrivateEquityTest(testToEvaluateId)) {
            onContinueOperation();
        }
    }

    buildOmitTest() {
        const link = (
            <OKLink
                onClick={() => {
                    this.props.onOmmitOperation()
                }}
                modifier="emphasize"
            >
                <FormattedText value="broker-convenienceMifidTestSuspendedRejectLinkText" />
            </OKLink>
        );

        return (
            <p className="broker-suspended-mifid-test__rejected-text">
                <FormattedTextWithComponents
                    value="broker-convenienceMifidTestSuspendedRejectText"
                    injectedComponents={[
                        link
                    ]}
                />
            </p>
        );
    }

    render() {
        const { lastExecutionTimestamp } = this.props;
        const title = formatText('broker-convenienceMifidTestSuspendedTitle');
        const subtitle = formatText('broker-convenienceMifidTestSuspendedSubtitle');

        const continueButtonLabel =
            this.props.firstTimePerformingTest ?
            'broker-convenienceMifidTestSuspendedFirstTimePerformingTestContinueButton':
            'broker-convenienceMifidTestSuspendedContinueButton';

        const lastExecutionMoment = moment(lastExecutionTimestamp);

        const dateOfTest = lastExecutionTimestamp != null && lastExecutionMoment.isValid()
            ? DateHelper.buildFormattedDate(lastExecutionMoment, DATE_FORMAT_COMPLETE)
            : HYPHEN;

        return (
            <ContentBox title={title} titleSeparator={true}>
                <h2 className="broker-suspended-mifid-test__title">{subtitle}</h2>
                <p className="broker-suspended-mifid-test__info">
                    {this.props.disclaimerText}
                </p>
                <div className="broker-suspended-mifid-test__subtitle">
                    <FormattedText value="consultMiFID-dateLastEvaluation" format="uppercase"/>
                </div>
                <div className="broker-suspended-mifid-test__info-bold">
                    {dateOfTest}
                </div>
                <div className="broker-suspended-mifid-test__disclaimer">
                    <p>
                        <FormattedText value="broker-convenienceMifidTestSuspendedDisclaimerTextOne"/>
                    </p>
                    <p>
                        <FormattedText value="broker-convenienceMifidTestSuspendedDisclaimerTextTwo"/>
                    </p>
                    <p>
                        <FormattedText value="broker-convenienceMifidTestSuspendedDisclaimerTextThree"/>
                    </p>
                </div>
                {this.buildOmitTest()}
                <footer className="broker-suspended-mifid-test__footer">
                    <div className="row">
                        <div className="col-xs-6">
                            <OKLink
                                modifier="inherit-styles"
                                to={this.props.cancelPath}
                            >
                                <FormattedText value="broker-convenienceMifidTestSuspendedCancelButton"/>
                            </OKLink>
                        </div>
                        <div className="col-xs-6 text-right">
                            <div className="broker-suspended-mifid-test__button">
                                <OKButton modifier="secondary" onClick={this.props.onContinueOperation}>
                                    <FormattedText value={continueButtonLabel}/>
                                </OKButton>
                            </div>
                        </div>
                    </div>
                </footer>
            </ContentBox>
        );
    }
}

BrokerSuspendedMiFIDTest.propTypes = {
    onContinueOperation: PropTypes.func.isRequired,
    disclaimerText: PropTypes.string.isRequired,
    cancelPath: PropTypes.string.isRequired,
    isCancelPathAbsolute: PropTypes.string.isRequired,
    lastExecutionTimestamp: PropTypes.number,
    firstTimePerformingTest: PropTypes.bool,
    onMiFIDResultDisplayed: PropTypes.func,
    immBrokerConvenienceMiFIDTest: PropTypes.object,
    onCreateTransferOfDerivatives: PropTypes.func,
    startCorporativeOperationCashCharge: PropTypes.func,
    onContinueToCorporateOperationBuyRights: PropTypes.func,
    startCorporativeOperationSubscriptionFromMifid: PropTypes.func,
    onContinueToInternalTransferFund: PropTypes.func,
    onContinueToExternalTransferFund: PropTypes.func,
    onOmmitOperation: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerSuspendedMiFIDTest;
module.exports.BrokerSuspendedMiFIDTest = connect(
  state => ({
    immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
  }),
  {
    onCreateTransferOfDerivatives: BrokerCreateTransferOfDerivativesAction.beginOperation,
    startCorporativeOperationCashCharge: BrokerCashChargeActions.start,
    onContinueToCorporateOperationBuyRights: BrokerRightsBuyActions.continueOperationFromMifid,
    startCorporativeOperationOpv: BrokerStocksPurchaseOrderActions.start,
    startCorporativeOperationSubscriptionFromMifid: BrokerSubscriptionActions.startFromMifid,
    onContinueToInternalTransferFund: InternalTransferFundActions.continueInternalTransferFundFromMifid,
    onContinueToExternalTransferFund: BrokerExternalTransferFundActions.continueFromMifid,
  }
)(BrokerSuspendedMiFIDTest)

